import accordionAria from "./accordion-aria"


class NativeReviews extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click',() => {
      this.jumpToTrustpilot();
    })
  }

  jumpToTrustpilot() {
    document.querySelector('#reviews').scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

}

customElements.define("native-reviews", NativeReviews);